


























































































import { snakeCase } from 'lodash'
import { Component, Prop, VModel, Watch } from 'vue-property-decorator'

import DrawerWidthMixin from '../../../../../../logic/helpers/DrawerWidthMixin'
import { CustomMediaTypes } from '../../../types'
import MediaManager from '../../logic/MediaManager'
import { FileType } from '../../types'
import FileTypeButton from './FileTypeButton.vue'
import MediaUploader from './MediaUploader.vue'

@Component({
  components: {
    FileTypeButton,
    MediaUploader,
  },
  data() {
    return {
      FileType
    }
  }
})
export default class UploadMediaModal extends DrawerWidthMixin {
  @VModel() isOpen!: boolean

  @Prop() mediaManager!: MediaManager

  @Prop() blacklistMediaButtonTypes!: Array<FileType>
  @Prop({ type: String }) mediaButtonsMessage!:string

  @Prop() availableFileTypes!: () => Array<FileType>

  @Prop() customMediaTypes!: CustomMediaTypes

  currentStep: 'select' | 'upload' = "select"

  @Watch('isOpen')
  isOpenWatcher(val: boolean): void {
    if (val && this.uploadFileTypes.length === 1) {
      this.mediaManager.setFileType(this.uploadFileTypes[0].type)
    }
  }

  handleModalBackButtonClick() {
    if (this.currentStep === "upload" && [ FileType.TopMessagePreview, FileType.MessagePreview ].includes(this.mediaManager.selectedType!)) {
      this.mediaManager.setFileType(FileType.MessagePreview)
    } else {
      this.mediaManager.selectedType = null;
    }

    this.currentStep = "select"
  }

  isButtonTypeInBlacklist(type: FileType) {
    return this.blacklistMediaButtonTypes.includes(type)
  }

  get uploadFileTypes() {
    return this.availableFileTypes()
      .filter(t => t !== FileType.Custom)
      .filter(t => ![ FileType.TopMessagePreviewUrl, FileType.MessagePreviewUrl, FileType.SpoilerImage, FileType.SpoilerVideo, FileType.SpoilerAnimation ].includes(t))
      .map((type: FileType) => ({ type, subType: type.toString(), icon: MediaManager.getFileIcon(type), disabled: this.isButtonTypeInBlacklist(type) }))
      .concat(this.customMediaTypes?.types.map(t => ({ type: t.type, icon: t.icon, subType: t.subType, disabled: this.isButtonTypeInBlacklist(t.type) })) ?? [])
      .sort((a, b) => a.disabled ? 1 : 0)
  }

  get uploadMediaModalTitle() {
    if (this.mediaManager.selectedType === null) {
      return this.$t('file_type_to_upload_choose')
    }

    return this.$t(`file_type_to_upload_${ snakeCase(this.mediaManager.selectedType) }`)
  }

  get selectedCustomType() {
    return this.customMediaTypes.types.find(t => t.subType === this.mediaManager.selectedCustomSubType)
  }

  handleSetFile(typeData: { type:FileType, subType: string } | null) {
    if (typeData && typeData.type) {
      this.mediaManager.setFileType(typeData.type)
      this.mediaManager.setFileSubType(typeData.subType)

      if (typeData.type !== FileType.MessagePreview) {
        this.currentStep = 'upload'
      }
    }
  }
}
